import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";
const NotFoundPage = () => {
    return (_jsxs("div", { className: "not-found-container", children: [_jsx("h1", { children: "404" }), _jsx("h2", { children: "Page Not Found" }), _jsx("p", { children: "The page you're looking for doesn't exist or has been moved." }), _jsx(Link, { to: "/", className: "home-link", children: "\u2190 Return to Home" })] }));
};
export default NotFoundPage;
